<script>
import CurrentExam from "@/components/exams/currentExam.vue";

export default {
  name: "exam",
  components: {CurrentExam}
}
</script>

<template>
  <current-exam />
</template>

<style scoped>

</style>